<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <div class="pix-alert">
          <span>
            Cole o par Public key + Secret key de
            <strong>Paggo365 → Aplicações API</strong>. Ao salvar, o webhook de
            baixa automática é provisionado na API.
          </span>
        </div>

        <div class="pix-alert pix-alert-fee">
          <span>
            Taxa Paggo365: <strong>2,99%</strong> por transação Pix.
            Esse valor é cobrado pelo gateway sobre o valor pago pelo comprador.
          </span>
        </div>

        <div class="pix-alert pix-alert-min">
          <span>
            <strong>⚠️ Valor mínimo: R$ 5,00</strong><br />
            Cada compra precisa totalizar <strong>no mínimo R$ 5,00</strong>
            (preço do número × quantidade). Valores abaixo disso (ex.: R$ 2,00)
            são rejeitados pela API e o Pix não é gerado. Ajuste o preço da
            cota ou a quantidade mínima da campanha antes de usar o Paggo365.
          </span>
        </div>

        <div class="quote-form">
          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Public key</span
              >
              <input
                v-model="paggo365.public_key"
                type="text"
                class="form-control default-bordered-input"
                placeholder="pk_..."
              />
            </label>
          </div>

          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Secret key</span
              >
              <input
                v-model="paggo365.secret_key"
                type="password"
                class="form-control default-bordered-input"
                placeholder="sk_..."
              />
            </label>
          </div>

          <div class="button-field">
            <button
              @click="save"
              class="btn submit-button"
              :disabled="!isFieldsFilled"
            >
              Salvar
            </button>
            <button @click="closeModal" class="btn cancel-button">
              Cancelar
            </button>
          </div>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    receivedPaggo365: {
      type: Object,
      default: () => ({
        public_key: "",
        secret_key: "",
      }),
    },
  },
  data() {
    return {
      title: "Configuração Paggo365",
      paggo365: {
        public_key: this.receivedPaggo365?.public_key || "",
        secret_key: this.receivedPaggo365?.secret_key || "",
      },
    };
  },
  watch: {
    receivedPaggo365: {
      handler(next) {
        if (next && Object.keys(next).length > 0) {
          this.paggo365 = {
            public_key: next?.public_key || "",
            secret_key: next?.secret_key || "",
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    isFieldsFilled() {
      return (
        String(this.paggo365?.public_key || "").trim() !== "" &&
        String(this.paggo365?.secret_key || "").trim() !== ""
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    save() {
      if (!this.isFieldsFilled) {
        alert("Preencha Public key e Secret key.");
        return;
      }
      let publicKey = String(this.paggo365.public_key || "").trim();
      let secretKey = String(this.paggo365.secret_key || "").trim();

      // Paggo365 usa gpk_ para a public e gsk_ para a secret; colar invertido é comum.
      if (publicKey.startsWith("gsk_") && secretKey.startsWith("gpk_")) {
        [publicKey, secretKey] = [secretKey, publicKey];
      }

      if (publicKey.startsWith("gsk_") || secretKey.startsWith("gpk_")) {
        alert(
          "Chaves invertidas: a Public key começa com gpk_ e a Secret key com gsk_."
        );
        return;
      }

      const payload = { public_key: publicKey, secret_key: secretKey };
      this.paggo365 = { ...payload };
      this.$emit("update:paggo365Form", payload);
      this.$emit("updatePayment", payload);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 600px;
  max-width: 100%;
  max-height: 90%;
  overflow: auto;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: sans-serif;
  font-size: 26px;
  color: #111111;
  margin: 0;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-body {
  margin: 20px 0 0 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.button-field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.cancel-button {
  background-color: #e0e0e0;
  color: #0f172a;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  margin-bottom: 0;

  &:hover {
    background-color: #d6d6d6;
    color: #0f172a;
  }
}

.submit-button {
  background-color: #661cb0;
  color: white;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    background-color: #7b23d3;
    color: white;
  }
}

.quote-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pix-alert {
  background-color: #2352d3;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 26px;

  span {
    color: white;
    font-size: 15px;
  }
}

.pix-alert-fee {
  background-color: #0f766e;
  margin-top: -12px;
}

.pix-alert-min {
  background-color: #b45309;
  margin-top: -12px;
}

.default-bordered-input {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 6px;
}
</style>
